import {taskList,taskSubmit,topupList,errorMsgList,retryUpload} from 'api/taskTopup';
import Cookies from 'js-cookie';

const taskTopup = {
    state: {
        account: '',
        status: '',
        email: '',
        uid: Cookies.get('uid'),
        acc: Cookies.get('acc'),
        avatar: '',
        introduction: '',
        roles: [],
        setting: {
            articlePlatform: []
        }
    },

    mutations: {

    },

    actions: {
        taskList({commit},params) {
            return new Promise((resolve, reject) => {
                taskList(params.createTimeStart, params.createTimeEnd, params.taskNo, params.status, params.agent, params.type, params.psize, params.currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        taskSubmit({commit},params) {
            return new Promise((resolve, reject) => {
                taskSubmit(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        topupList({commit},params) {
            return new Promise((resolve, reject) => {
                topupList(params.task_no, params.status, params.card_no, params.product_id,params.psize, params.currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        errorMsgList({commit},params) {
            return new Promise((resolve, reject) => {
                errorMsgList(params.task_no, params.psize, params.currentPage).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
        retryUpload({commit},params) {
            return new Promise((resolve, reject) => {
                retryUpload(params).then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
            });
        },
    }
};

export default taskTopup;



// WEBPACK FOOTER //
// ./src/store/modules/taskTopup.js